const mutations = {
  setBillRequestsList(state, data) {
    state.billRequestsList = data;
  },
  setAllBillRequestsList(state, list) {
    state.allBillRequests = list.data || list.rows || list || [];
    state.billRequestMeta = list.meta || {};
  },
  setBillRequest(state, billRequest) {
    state.billRequest = billRequest;
  }
};

export default mutations;
